import { render, staticRenderFns } from "./EsLoader.vue?vue&type=template&id=72c0ee12&scoped=true&"
import script from "./EsLoader.vue?vue&type=script&lang=js&"
export * from "./EsLoader.vue?vue&type=script&lang=js&"
import style0 from "./EsLoader.vue?vue&type=style&index=0&id=72c0ee12&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0ee12",
  null
  
)

export default component.exports